import { useLocalStore } from 'mobx-react-lite';

import { ComplaintType, IMessageComplaint } from '@gem/models/moderationModel';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps } from '@gem/popups';

import { moderationModel } from 'APP/model/model';
import Entities from 'STORE';

import { IReportFormData } from '../../components/ReportForm/ReportForm.types';

interface IReportMessagePopupPresenter {
  onSubmit(formData: IReportFormData): Promise<void>;
  onClose(): void;
}

export interface IReportMessagePopupParams {
  groupId: string;
  messageId: string;
}

export function useReportMessagePopupPresenter({
  params,
  popupInstance,
}: ICommonPopupsProps<IReportMessagePopupParams>): IReportMessagePopupPresenter {
  const { groupId, messageId } = params!;
  const { t } = useTranslation();

  const presenter = useLocalStore(() => ({
    async onSubmit(formData: IReportFormData): Promise<void> {
      try {
        await moderationModel.sendComplaint<IMessageComplaint>({
          ...formData,
          complaint: {
            complaintType: ComplaintType.Message,
            groupId,
            messageId,
          },
        });

        Entities.toast.show(t('content_moderation_sent_message'));
      } catch {
        Entities.toast.show(t('something_went_wrong'));
      }

      presenter.onClose();
    },

    onClose(): void {
      popupInstance.close();
    },
  }));

  return presenter;
}
